import { Injectable } from '@angular/core';
import { AuthState } from '../../state/auth/auth.state';
import { Store } from '@ngrx/store';
import { selectToken } from '../../state/auth/auth.selectors';
import { Observable, of, switchMap, take } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { logout } from '../../state/auth/auth.actions';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  private excludedUrls: string[] = ['/auth'];

  constructor(private store: Store<AuthState>, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldExclude = this.excludedUrls.some((url) => req.url.includes(url));

    if (shouldExclude) {
      console.log('exluding');
      // Pass the request through unmodified
      return next.handle(req);
    }

    let token: string = '';
    // Subscribe to the token state and update the interceptor's token
    // Wait for the token from the store
    return this.store.select(selectToken).pipe(
      take(1), // Take the latest token and complete the observable
      switchMap((token) => {
        if (token && this.isTokenExpired(token)) {
          console.log('Token expired, logging out...');
          this.store.dispatch(logout());
          this.router.navigate(['/auth/login']);
          return of(); // Complete the observable, no further HTTP requests are made
        }
        // Only add the header if a token exists
        if (token) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
        return next.handle(req); // Pass the modified or original request
      })
    );
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1])); // Decode the JWT payload
      const expiryTime = payload.exp * 1000; // Convert to milliseconds
      return Date.now() > expiryTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true; // Treat as expired if decoding fails
    }
  }
}
